import React from 'react';
import { RaisedButton } from 'material-ui';

class PortsAreasToggler extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { toggleShowPorts, toggleShowAreas, showChilds } = this.props;

        return (
            <div className='paper-block margin-10' style={{textAlign: "center", paddingTop: '10px'}}>
                <RaisedButton 
                    label='Ports' 
                    secondary={showChilds === 'ports'}
                    style={{marginBottom: '10px'}} 
                    onClick={toggleShowPorts}
                />
                <RaisedButton 
                    label='Areas' 
                    secondary={showChilds !== 'ports'} 
                    onClick={toggleShowAreas}
                />
            </div>
        );
    };
}

export default PortsAreasToggler;


// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/PortsAreasToggler.jsx